"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerIntegrationApiSource = exports.RetailIntegrationSource = exports.ProductForm = exports.CustomerLanguage = exports.CustomerTableType = exports.ProductImageProvider = void 0;
var ProductImageProvider;
(function (ProductImageProvider) {
    ProductImageProvider["kRuoka"] = "kRuoka";
    ProductImageProvider["foodie"] = "foodie";
})(ProductImageProvider = exports.ProductImageProvider || (exports.ProductImageProvider = {}));
var CustomerTableType;
(function (CustomerTableType) {
    CustomerTableType["retail"] = "retail";
    CustomerTableType["pharmacy"] = "pharmacy";
    CustomerTableType["fish"] = "fish";
    CustomerTableType["meat"] = "meat";
})(CustomerTableType = exports.CustomerTableType || (exports.CustomerTableType = {}));
var CustomerLanguage;
(function (CustomerLanguage) {
    CustomerLanguage["fi"] = "fi";
    CustomerLanguage["sv"] = "sv";
})(CustomerLanguage = exports.CustomerLanguage || (exports.CustomerLanguage = {}));
var ProductForm;
(function (ProductForm) {
    ProductForm["general"] = "general";
    ProductForm["retail"] = "retail";
    ProductForm["pharmacy"] = "pharmacy";
})(ProductForm = exports.ProductForm || (exports.ProductForm = {}));
/**
 * Supported integration data sources.
 */
var RetailIntegrationSource;
(function (RetailIntegrationSource) {
    /** k-ruoka api */
    RetailIntegrationSource["kRuoka"] = "kRuoka";
    /** s-kaupat.fi api */
    RetailIntegrationSource["sok"] = "sok";
})(RetailIntegrationSource = exports.RetailIntegrationSource || (exports.RetailIntegrationSource = {}));
var CustomerIntegrationApiSource;
(function (CustomerIntegrationApiSource) {
    CustomerIntegrationApiSource["rKioski"] = "rKioski";
})(CustomerIntegrationApiSource = exports.CustomerIntegrationApiSource || (exports.CustomerIntegrationApiSource = {}));
//# sourceMappingURL=customers.js.map